import type { HotelMapCoordinate } from "../types";

/** 酒店地图默认中心点。 */
export const DEFAULT_CENTER: HotelMapCoordinate = {
  lng: 116.397428,
  lat: 39.90923,
};

/** 酒店地图默认缩放级别。 */
export const DEFAULT_ZOOM = 16.3;

/** 酒店地图允许查询 POI 的最小缩放级别。 */
export const MIN_QUERY_ZOOM = 11;

/** 酒店地图搜索防抖毫秒数。 */
export const SEARCH_DEBOUNCE = 300;

/** 酒店地图视口查询防抖毫秒数。 */
export const VIEWPORT_DEBOUNCE = 500;

/** 酒店地图 React Query 键生成器。 */
export const hotelMapQueryKeys = {
  /** 生成地点搜索查询键。 */
  search: (query: string) => ["hotel-map", "search", query] as const,
};
